import http from '@/http-common'

class EmployeeKpiFilterService {
  searchEmployees(departmentId = -3, source = 'ALL') {
    return http.get('statistics/employees', {
      params: { departmentId, source }
    })
  }
}

export default new EmployeeKpiFilterService()
